module.exports = __webpack_public_path__ + "media/pricing/ArtBooksProduct-mobile-6a83fa24.png";